import { render, staticRenderFns } from "./sportTeam.vue?vue&type=template&id=b68c8882"
import script from "./sportTeam.vue?vue&type=script&lang=js"
export * from "./sportTeam.vue?vue&type=script&lang=js"
import style0 from "./sportTeam.vue?vue&type=style&index=0&id=b68c8882&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b68c8882')) {
      api.createRecord('b68c8882', component.options)
    } else {
      api.reload('b68c8882', component.options)
    }
    module.hot.accept("./sportTeam.vue?vue&type=template&id=b68c8882", function () {
      api.rerender('b68c8882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/team/sportTeam.vue"
export default component.exports